import React from "react";

export default function Stat({ label, value, color }) {
  return (
    <div className="bg-white/5 border border-white/10 rounded-xl p-3">
      <div className="text-xs font-display uppercase tracking-wider text-white/60">
        {label}
      </div>
      <div className="font-display font-black text-2xl" style={{ color }}>
        {value}
      </div>
    </div>
  );
}
